import './App.css';
import AuthRoute from 'shared/routes/AuthRoutes';
import Toast from 'shared/components/toast/Toast';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'react-circular-progressbar/dist/styles.css';
import { useEffect } from 'react';
import { initialConfig } from 'shared/utils/Interceptor';
import { useSelector } from 'react-redux';

function App() {
    const statedata = useSelector(state=> state) ;

    useEffect(() => {
        initialConfig();
    }, []);
    console.log(statedata,"statedata");
    
    return (
        <div className="App">
            <AuthRoute />
            <Toast />
        </div>
    );
}

export default App;
